/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:d19a8955-937e-4b96-aad2-ee0dc654fb98",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_wsiZWWcCn",
    "aws_user_pools_web_client_id": "5ass4h8dl2lae02h57p2c00r3m",
    "oauth": {
        "domain": "x2naccesscontrolv2fa133d85-fa133d85-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://portal.x2n.com/",
        "redirectSignOut": "https://portal.x2n.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://hw3sotck6zeqfawl2pgyu7nfoq.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "geo": {
        "amazon_location_service": {
            "region": "us-west-2",
            "maps": {
                "items": {
                    "SatelliteLocationMap-dev": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "SatelliteLocationMap-dev"
            }
        }
    }
};


export default awsmobile;
